import type { TokenHandshakeHandler } from './types'
import { resetHandshakeAuthStore } from '../token-handshake'

export const loginHandler: TokenHandshakeHandler = async (params, { authStore }) => {
	const login = String(params?.login || '').trim()
	const password = String(params?.password || '').trim()

	if (!login || !password) {
		return {
			error: { code: -32602, message: 'Invalid params' }
		}
	}

	resetHandshakeAuthStore(authStore)

	await authStore.login({
		login,
		password,
		login_type: 'grid'
	})

	const authorization = authStore.getAuthorization as any
	return {
		result: {
			grid: authorization?.confirm_data
		}
	}
}
